import React from 'react'
import { Link } from 'react-router-dom'

export default () => (
	<div>
		<h1>Instructive Space - Home</h1>
		<Link to="/auth">Log in / Sign up</Link>
	</div>
)
